import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'

import axios from 'axios'

import isUserSignedIn from '../../../../auth/is-user-signed-in'

import './level-title.scss'

const LevelTitle = (props) => {
  const [ is_active, setActive ] = useState(false)
  const [ authenticated, setAuthenticated ] = useState(false)

  const axios_cancel_token = axios.CancelToken.source()

  const formatUrl = (active_url) => {
    return active_url[active_url.length - 1] === '/'
      ? active_url.slice(0, -1)
      : active_url
  }

  const compareUrls = (first, second) => {
    return formatUrl(first) === formatUrl(second)
  }

  const isActive = () => {
    if (
      !props.level.class
      || !props.level.class.includes('title-only')
    ) {
      props.level.section_url
        // don't change to compareUrls
        ? setActive(props.active_url.includes(props.level.section_url))
        : setActive(compareUrls(props.active_url, props.level.url))
    }
  }

  const checkSignIn = async () => {
    const is_signed_in = await isUserSignedIn(axios_cancel_token)
    //Is an anti-pattern? It may be only supressing the 'trying to setState on un-mounted component', but reference to unmounted component still exists.
    if (is_signed_in !== undefined) {
      setAuthenticated(is_signed_in)
      isActive()
    }

  }

  useEffect(() => {
    checkSignIn()

    return (() => {
      try {
        axios_cancel_token.cancel()
      } catch (error) {
        console.log(error)
      }
    })
  }, [])

  useEffect(() => {
      isActive()
      setAuthenticated(props.authenticated)
  }, [props.active_url, props.authenticated])

  // Only render title if non AUTH page or no matter what if user if authenticated
  if (!props.level.auth || authenticated) {
    return (
      <React.Fragment>
        {props.level.class === "title-only hr-top" &&
          <hr style={{ marginTop: '.25rem', marginBottom: '.75rem' }} />
        }
        {is_active &&
          <div
            className={
              `level-title-${props.level_number}
              active
              current
              ${ props.level.class || '' }
              `
            }
          >
            {props.level.subtitle &&
              <div className="d-flex flex-wrap justify-content-center">
                <span className="w-100 text-center level-subtitle">
                  {props.level.subtitle}
                </span>
                <span className="w-100 text-center level-title">
                  {props.level.title}
                </span>
              </div>
            }
            {props.level.chapter_index &&
              <div className="d-flex">
                <span className="level-title">
                  {props.level.title}
                </span>
                <span className="level-subtitle ml-auto">
                  {props.level.chapter_index}
                </span>
              </div>
            }
            {!props.level.subtitle && !props.level.chapter_index &&
              props.level.title
            }
          </div>
        }
        {!is_active
        && (
          !props.level.class
          ||
          !props.level.class.includes('title-only')
        ) &&
          <Link
            //Only go to student url if not signed in and it exists in JSON
            to={authenticated
              ?
              props.level.url
              :
              props.level.student_url || props.level.url
            }
          >
            <div
              className={`
                level-title-${props.level_number}
                ${props.level.class || ''}
              `}
              >
              {props.level.subtitle &&
                <div className="d-flex flex-wrap justify-content-center">
                  <span className="w-100 text-center level-subtitle">
                    { props.level.subtitle }
                  </span>
                  <span className="w-100 text-center level-title">
                    { props.level.title }
                  </span>
                </div>
              }
              {props.level.chapter_index &&
                <div className="d-flex">
                  <span className="level-title">
                    { props.level.title }
                  </span>
                  <span className="level-subtitle ml-auto">
                    { props.level.chapter_index }
                  </span>
                </div>
              }
              {!props.level.subtitle && !props.level.chapter_index &&
                props.level.title
              }
            </div>
          </Link>
        }
        {props.level.class
        && props.level.class.includes('title-only')
        &&
          <div
            className={`
              level-title-${props.level_number}
              ${ props.level.class || '' }
            `}
          >
            {props.level.subtitle &&
              <div className="d-flex flex-wrap justify-content-center">
                <span className="w-100 text-center level-subtitle">
                  {props.level.subtitle}
                </span>
                <span className="w-100 text-center level-title">
                  {props.level.title}
                </span>
              </div>
            }
            {props.level.chapter_index &&
              <div className="d-flex align-items-center">
                <span className="level-title">
                  {props.level.title}
                </span>
                <span className="level-subtitle ml-auto">
                  {props.level.chapter_index}
                </span>
              </div>
            }
            {!props.level.subtitle && !props.level.chapter_index &&
              props.level.title
            }
          </div>
        }
        {props.level.class === "title-only hr-bottom" &&
          <hr style={{ marginTop: '.25rem', marginBottom: '.75rem' }} />
        }
      </React.Fragment>
    )
  } else {
    return (
      <React.Fragment />
    )
  }
}

export default LevelTitle